import { skipToken, useQuery } from '@tanstack/react-query';

import { IMedia } from '@/interfaces/IMedia';

import api from '../services/api';

export const createMedia = ({
  file_name,
  content_type
}: {
  file_name: string;
  content_type: string;
}): Promise<{ data: { data: { media: IMedia } } }> => api.post(`/api/frontend/media`, { file_name, content_type });

export const getMedia = (mediaId: string): Promise<{ data: { data: { media: IMedia } } }> =>
  api.get(`/api/frontend/media/${mediaId}`);

export const useMedia = (mediaId: string | undefined) =>
  useQuery({
    queryKey: ['media', mediaId],
    queryFn: mediaId ? () => getMedia(mediaId) : skipToken,
    select: data => data.data.data.media
  });
